import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=1a858c57"
import script from "./Authors.vue?vue&type=script&lang=js"
export * from "./Authors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports